import React from 'react';
import './mcp.css';
import NewCampaignUX from '../Campaigns/NewCampaignUX';
import McpHeader from '../../../components/mcp/McpHeader';

const McpCampaign = () => {
  return (
    <div className="mcp-page" style={{ minHeight: '100vh', overflowY: 'auto' }}>
      <McpHeader title="Campaign" />
      <div className="mx-auto w-full max-w-7xl p-6 md:p-7">
        <NewCampaignUX singlePage />
      </div>
    </div>
  );
};

export default McpCampaign;
